import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { isBoxBuilderSelectProductsDrawerShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { currentStepSelector, hasUnsavedChangesSelector } from '../../../redux/box-builder/box-builder.selectors';
import { onCloseBoxBuilderPopup } from '../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../redux/box-builder/box-builder.constants';
import BoxBuilderSelectProductsDrawer from './box-builder-select-products-drawer';
const STEPS_TO_SHOW_DRAWER = [STEPS.SELECT_PRODUCTS_FOR_BOX, STEPS.SELECT_ADDONS_FOR_BOX];
const isOpenSelector = createSelector(currentStepSelector, isBoxBuilderSelectProductsDrawerShownSelector, (currentStep, isShown) => {
  return STEPS_TO_SHOW_DRAWER.includes(currentStep) && isShown;
});
const mapStateToProps = createStructuredSelector({
  open: isOpenSelector,
  currentStep: currentStepSelector,
  hasUnsavedChanges: hasUnsavedChangesSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: onCloseBoxBuilderPopup(dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(BoxBuilderSelectProductsDrawer);